/* @flow */

export function getDefaultActivityType(): ?string {
    return typeof NutshellFrontendSettings !== 'undefined'
        ? NutshellFrontendSettings.defaultActivityType
        : null;
}
